import type { FC } from "react";

import LoadingBars from "../../images/loading-bars.svg?react";

export const LoadingFrame: FC<{
  message?: string | null;
  className?: string;
}> = ({ message, className }) => {
  const loadingBarColor: { [k: string]: any } = {};

  const buildingsColors = {
    divisait_publico_test: "#007DBC",
  };
  const pathName = window.location.pathname;
  const pathIdValue = pathName.startsWith("/id/")
    ? (pathName.slice(4, pathName.length) as keyof typeof buildingsColors)
    : null;
  if (pathIdValue && buildingsColors[pathIdValue]) {
    loadingBarColor.fill = buildingsColors[pathIdValue];
    loadingBarColor.stroke = loadingBarColor.fill;
  }
  return (
    <div className={className}>
      <LoadingBars className="loading__icon" />
      {
        <div aria-live="polite" className="loading__message">
          {message ?? ""}
        </div>
      }
    </div>
  );
};
